import { Map, useMap } from "@vis.gl/react-google-maps";
import { Modal } from "antd";
import { getEventText } from "lib/utils";
import { useEffect, useState } from "react";
import PoiMarkers from "ui/map/poi-markers";

export default function MarkPresetMap({ alert, visible, onClose }) {
  const [locations, setLocations] = useState([]);
  const map = useMap();
  useEffect(() => {
    if (!alert || !visible || !map) return;

    if (
      !isNaN(alert?.location?.polygon?.latitude) &&
      !isNaN(alert?.location?.polygon?.longitude)
    ) {
      const lat = alert?.location?.polygon?.latitude;
      const lng = alert?.location?.polygon?.longitude;
      const _locations = [
        {
          key: alert.id.toString(),
          name: alert.eventTypes[0],
          location: { lat, lng },
          title: getEventText(alert.eventTypes[0]),
          type: "alertMap",
          disableInfoWindow: true,
        },
      ];
      setLocations(_locations);
      map.panTo(new google.maps.LatLng(lat, lng));
      map.setZoom(19);
    }
  }, [alert, visible, map]);

  return (
    <Modal
      open={visible}
      onClose={onClose}
      okButtonProps={{ style: { display: "none" } }}
      cancelButtonProps={{ className: "primaryButton bordered" }}
      cancelText="Close"
      width={600}
      height={600}
      onCancel={onClose}
    >
      <div style={{ height: "500px" }}>
        <Map
          draggableCursor={"unset"}
          defaultZoom={4}
          defaultCenter={{ lat: 37.0902, lng: -95.7129 }}
          mapId="a060739f521f7239"
          //mapTypeId={"hybrid"}
        >
          <PoiMarkers pois={locations} />
        </Map>
      </div>
    </Modal>
  );
}
